import { createContext, useRef, useState } from 'react';

export const DownloadContext = createContext(null);

export function DownloadProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [includeItsActivity, setIncludeItsActivity] = useState(false);
  const [includeItsFootprint, setIncludeItsFootprint] = useState(false);
  const [errorLoadMsg, setErrorLoadMsg] = useState(new Set());
  const [errorMsg, setErrorMsg] = useState(new Set());
  const [successMsg, setSuccessMsg] = useState(new Set());
  const [successReportMsg, setSuccessReportMsg] = useState(new Set());
  const abortControllerRef = useRef(null);
  return (
    <DownloadContext.Provider
      value={{
        loading,
        setLoading,
        cancelLoading,
        setCancelLoading,
        includeItsActivity,
        setIncludeItsActivity,
        includeItsFootprint,
        setIncludeItsFootprint,
        errorLoadMsg,
        setErrorLoadMsg,
        errorMsg,
        setErrorMsg,
        successMsg,
        setSuccessMsg,
        successReportMsg,
        setSuccessReportMsg,
        abortControllerRef,
      }}
    >
      {children}
    </DownloadContext.Provider>
  );
}
